<template>
<div>
  

    <v-card color="grey lighten-5">
        <v-layout row wrap>
            <v-flex xs12 sm12>

                <v-toolbar size="120px" dark color="info">
                    <v-toolbar-title> {{'Paket Tur Rezervasyon'}}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn
          color="primary"
          @click="e1 = 2"
        >
        <v-icon right dark>undo</v-icon>
          Listeye Dön
        </v-btn>
        <v-btn
          color="primary"
          @click="e1 = 2"
        >
        <v-icon right dark>playlist_add_check</v-icon>
          Tamamla
        </v-btn>
                </v-toolbar>
            </v-flex>
        
        </v-layout>
    </v-card>
    <v-card color="grey lighten-5 pa-4">
        <v-layout row wrap>
            <v-flex xs12 sm12 md8>

              <v-stepper v-model="e1">
    <v-stepper-header>
      <v-stepper-step :complete="e1 > 1" step="1">Kişiler</v-stepper-step>

     

      <v-divider></v-divider>

      <v-stepper-step :complete="e1 > 2" step="2">Ek Masraflar</v-stepper-step>

      <v-divider></v-divider>

      <v-stepper-step step="3">Ödeme Bilgileri</v-stepper-step>
    </v-stepper-header>

    <v-stepper-items>
      <v-stepper-content step="1">
       <v-card>
        <v-layout row wrap>


        
        <v-flex pa-1 xs6 sm8 md8>
                                                                        <v-form ref="formkisiEkle"  lazy-validation>

                                                                            <v-flex pb-1 pt-1 xs12 sm12 md12>
                                                                                <v-layout row="" wrap="">

                                                                                    <v-flex xs12 pa-2 sm12 md12>

                                                                                        <v-layout row wrap>

                                                                                            <v-flex xs11 sm11 md11>
                                                                                                <v-icon medium="" color="red">
                                                                                                    person</v-icon>
                                                                                                &nbsp;
                                                                                                <span class=" font-weight-regular grey--text title">
                                                                                                    {{ $t('Personal-Information') }}
                                                                                                </span>
                                                                                                <v-divider>
                                                                                                </v-divider>
                                                                                            </v-flex>

                                                                                            <v-flex xs1 sm1 md1>
                                                                                                <v-layout justify-end>
                                                                                                    <v-btn  icon color="red">
                                                                                                        <v-icon small color="white">
                                                                                                            search
                                                                                                        </v-icon>
                                                                                                    </v-btn>
                                                                                                </v-layout>
                                                                                            </v-flex>

                                                                                        </v-layout>

                                                                                    </v-flex>

                                                                                    <v-flex pb-1 pt-1 xs6 sm6 md6>
                                                                                        <v-layout row="" wrap="">

                                                                                            <!-- <v-flex xs12 sm12 md12>
                                                <pnraracomp hide-details v-model="Rez.pNR_No" v-on:kodonchange="pnrchange">
                                                </pnraracomp>
                                              </v-flex> -->
                                                                                            <v-flex xs12 sm12 md12>
                                                                                                <kisitip :autofocuss="true" :rules="[v => !!v || $t('Mandatory-Areas')]" >
                                                                                                </kisitip>
                                                                                            </v-flex>
                                                                                            <!-- <v-flex xs12 sm12 md12>
                                                <v-text-field hide-details label="Yaş" v-model="Adres.yas">
                                                </v-text-field>
                                              </v-flex> -->
                                                                                            <v-flex xs12 sm12 md12>
                                                                                                <v-text-field mask="###########" hide-details :label="$t('Identitynumber_label')" >
                                                                                                </v-text-field>
                                                                                            </v-flex>
                                                                                            <!-- <v-flex xs12 sm12 md12>
                                                <v-text-field hide-details :label="$t('Member-No')" v-model="Adres.uyeNo">
                                                </v-text-field>
                                              </v-flex> -->

                                                                                            <v-flex xs12 sm12 md6>
                                                                                                <v-text-field hide-details  :label="$t('Name_label') + '(max 50)'" >
                                                                                                </v-text-field>
                                                                                            </v-flex>

                                                                                            <v-flex xs12 sm12 md6>
                                                                                                <v-text-field hide-details :label="$t('Surname_label') + '(max 50)'" >
                                                                                                </v-text-field>
                                                                                            </v-flex>

                                                                                            <v-flex v-if="false" xs12 sm12 md6>
                                                                                                <v-text-field hide-details :label="$t('Name_Surname_label') +  '(max 50)'" >
                                                                                                </v-text-field>
                                                                                            </v-flex>

                                                                                            <v-flex xs12 sm12 md12>

                                                                                                <v-textarea hide-details :label="$t('Address_label')" >
                                                                                                </v-textarea>
                                                                                            </v-flex>
                                                                                        </v-layout>
                                                                                    </v-flex>

                                                                                    <v-flex pb-1 pt-1 xs6 sm6 md6>
                                                                                        <v-layout row="" wrap="">

                                                                                            <v-flex pb-1 pt-1 xs12 sm12 md12>
                                                                                                <v-layout row="" wrap="">
                                                                                                    <v-flex xs12 sm12 md12>
                                                                                                        <tarihcomp :etiket="$t('Date-of-Birth')" v-bind:detaygizle="true" v-bind:defaultvalue="'yes'" >
                                                                                                        </tarihcomp>

                                                                                                    </v-flex>
                                                                                                    <v-flex xs12 sm12 md12>
                                                                                                        <v-select  hide-details  item-text="text" item-value="value" :label="$t('Sex')">
                                                                                                        </v-select>

                                                                                                    </v-flex>
                                                                                                    <v-flex xs12 sm12 md12>
                                                                                                        <v-text-field hide-details :label="$t('Telephone')" >
                                                                                                        </v-text-field>
                                                                                                    </v-flex>
                                                                                                    <v-flex xs12 sm12 md12>
                                                                                                        <v-text-field hide-details :label="$t('Mobilphonenumber_label')" >
                                                                                                        </v-text-field>
                                                                                                    </v-flex>
                                                                                                    <v-flex xs12 sm12 md12>
                                                                                                        <v-text-field hide-details :label="$t('Email_label')" >
                                                                                                        </v-text-field>
                                                                                                    </v-flex>
                                                                                                    <v-flex xs12 sm12 md12>
                                                                                                        <v-layout pt-2 justify-end row wrap>
                                                                                                            <!-- <v-btn flat color="primary" @click.native="YeniPNR()">Yeni Kayıt</v-btn> -->
                                                                                                            <v-btn flat color="primary" >
                                                                                                            {{$t('Add-to-Persons')}}
                                                                                                            </v-btn>

                                                                                                        </v-layout>
                                                                                                    </v-flex>
                                                                                                </v-layout>
                                                                                            </v-flex>
                                                                                        </v-layout>
                                                                                    </v-flex>

                                                                                </v-layout>
                                                                            </v-flex>
                                                                        </v-form>

        </v-flex>

        <v-flex xs12 pa-1 sm4 md4>
                                                                        <v-card color="grey lighten-5" flat>
                                                                            <v-layout row wrap>
                                                                                <v-flex xs12 pa-2 sm12 md12>
                                                                                    <v-icon medium="" color="grey">
                                                                                        view_headline</v-icon>
                                                                                    &nbsp;
                                                                                    <span class=" font-weight-regular grey--text subheading">
                                                                                        {{'Eklenen Kişiler'}}
                                                                                    </span>
                                                                                    <v-divider></v-divider>
                                                                                </v-flex>

                                                                                <v-flex xs12 sm12 md12>
                                                                                    <v-layout row wrap>

                                                                                        <v-flex  pa-2 xs12 sm12 md12>
                                                                                            <v-card flat="">
                                                                                                <v-layout row wrap>
                                                                                                    <v-flex xs12 sm12 md12>
                                                                                                        <v-card-actions>
                                                                                                            <v-layout row wrap>
                                                                                                                <v-flex xs12 sm12 md12>
                                                                                                                    <v-layout align-center="" justify-start="" fill-height="">
                                                                                                                        <v-icon color="red">
                                                                                                                            person
                                                                                                                        </v-icon>
                                                                                                                        &nbsp;
                                                                                                                        <span class="body-2 black--text font-weight-regular">
                                                                                                                            {{ $t('You-have-not-yet-added-person') }}
                                                                                                                        </span>
                                                                                                                    </v-layout>
                                                                                                                </v-flex>
                                                                                                            </v-layout>
                                                                                                        </v-card-actions>

                                                                                                    </v-flex>
                                                                                                </v-layout>

                                                                                            </v-card>
                                                                                        </v-flex>

                                                                                        <v-flex pa-2  xs12 sm12 md12>
                                                                                            <v-card flat="">
                                                                                                <v-layout row wrap>
                                                                                                    <v-flex xs12 sm12 md12>
                                                                                                        <v-card-actions>
                                                                                                            <v-layout row wrap>
                                                                                                                <v-flex xs6 sm2 md2>
                                                                                                                    <v-layout align-center="" justify-start="" fill-height="">
                                                                                                                        <v-icon color="red">
                                                                                                                            person
                                                                                                                        </v-icon>
                                                                                                                        &nbsp;
                                                                                                                        <span class="body-2 black--text font-weight-regular">
                                                                                                                         
                                                                                                                        </span>
                                                                                                                    </v-layout>
                                                                                                                </v-flex>

                                                                                                                <v-flex xs6 sm3 md3>
                                                                                                                    <v-layout align-center="" justify-start="" fill-height="">
                                                                                                                        <span class="body-2 black--text font-weight-regular">
                                                                                                                           person
                                                                                                                        </span>
                                                                                                                    </v-layout>
                                                                                                                </v-flex>

                                                                                                                <v-flex xs12 sm2 md2>
                                                                                                                    <v-layout align-start="" justify-start fill-height>
                                                                                                                        <v-card flat="">
                                                                                                                            <v-list-tile>
                                                                                                                                <v-list-tile-content>
                                                                                                                                    <v-list-tile-sub-title>
                                                                                                                                        <div class="font-weight grey--text caption ">
                                                                                                                                            <v-icon small color="grey">
                                                                                                                                                fingerprint
                                                                                                                                            </v-icon>
                                                                                                                                            &nbsp; {{ $t('Identitynumber_label') }}
                                                                                                                                        </div>
                                                                                                                                    </v-list-tile-sub-title>
                                                                                                                                    <v-list-tile-sub-title>
                                                                                                                                        <div class="font-weight green--text body-2 ">
                                                                                                                                           
                                                                                                                                        </div>
                                                                                                                                    </v-list-tile-sub-title>
                                                                                                                                </v-list-tile-content>
                                                                                                                            </v-list-tile>
                                                                                                                        </v-card>
                                                                                                                    </v-layout>

                                                                                                                </v-flex>

                                                                                                              

                                                                                                            </v-layout>
                                                                                                        </v-card-actions>

                                                                                                    </v-flex>
                                                                                                </v-layout>

                                                                                            </v-card>
                                                                                        </v-flex>
                                                                                    </v-layout>

                                                                                </v-flex>

                                                                            </v-layout>
                                                                        </v-card>
         </v-flex>
        </v-layout>
       </v-card>
       <v-card>
                   
                   
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
          color="primary"
          @click="e1 = 2"
        >
          Devam
        </v-btn>
                       
                    </v-card-actions>
      </v-card>
     
      
       
      
      </v-stepper-content>

      <v-stepper-content step="2">
        <v-card
          class="mb-5"
          color="grey lighten-1"
          height="200px"
        ></v-card>

        <v-btn
          color="primary"
          @click="e1 = 3"
        >
          Continue
        </v-btn>

        <v-btn flat>Cancel</v-btn>
      </v-stepper-content>

      <v-stepper-content step="3">
        <v-card
          class="mb-5"
          color="grey lighten-1"
          height="200px"
        ></v-card>

        <v-btn
          color="primary"
          @click="e1 = 1"
        >
          Continue
        </v-btn>

        <v-btn flat>Cancel</v-btn>
      </v-stepper-content>
    </v-stepper-items>
  </v-stepper>
            </v-flex>
            <v-flex xs12 sm12 md4 >
             <span style="padding-left: 18px;" class="title">REZERVASYON BİLGİLERİ</span> 
              <v-container>
    <v-row class="text-center">
      <v-col cols="12">
        <v-card
          class="d-flex align-content-start flex-wrap"
          color="grey lighten-2"
          flat
          tile
        >
          <v-card  class="pa-2 font-weight-bold" outlined tile>BÜYÜK İSKANDİNAVYA TURU</v-card>
        
        </v-card>
      </v-col>
    </v-row>
    <v-row class="text-center">
      <v-col cols="12">
        <v-card
          class="d-flex align-content-start flex-wrap"
          color="grey lighten-2"
          flat
          tile
        >
          <v-card  class="pa-2" outlined tile> 10 Gece - 11 Gündüz</v-card>
        
        </v-card>
      </v-col>
    </v-row>
    <v-row class="text-center">
      <v-col cols="12">
        <v-card
          class="d-flex align-content-start flex-wrap"
          color="grey lighten-2"
          flat
          tile
        >
          <v-card  class="pa-2" outlined tile>3* Otel</v-card>
        
        </v-card>
      </v-col>
    </v-row>
    <v-row class="text-center">
      <v-col cols="12">
        <v-card
          class="d-flex align-content-start flex-wrap"
          color="grey lighten-2"
          flat
          tile
        >
          <v-card  class="pa-2" outlined tile>Tur No: 32500</v-card>
        </v-card>
      </v-col>
    </v-row>
    <v-row class="text-center">
      <v-col cols="12">
        <v-card
          class="d-flex align-content-start flex-wrap"
          color="primary"
          flat
          tile
         
        >
          <v-card  class="pa-2 white--text" color="primary" outlined tile>Uçuş Bilgileri</v-card>
        </v-card>
      </v-col>
    </v-row>
    <v-row class="text-center">
      <v-col cols="12">
        <v-card
          class="d-flex align-content-start flex-wrap"
          color="grey lighten-2"
          flat
          tile
        >
          <v-card  class="pa-2" outlined tile>
            <v-icon>flight_takeoff</v-icon><br>
            <span> IST </span><br>
            <span> THY - 1453 </span><br>
            <span> Kalkış: 14:50 </span><br>
            <span> Varış: 18:50 </span>
          </v-card>
          <v-card  class="pa-2" outlined tile>
            <v-icon>flight_takeoff</v-icon><br>
            <span> IST </span><br>
            <span> THY - 1453 </span><br>
            <span> Kalkış: 14:50 </span><br>
            <span> Varış: 18:50 </span>
          </v-card>
        </v-card>
      </v-col>
    </v-row>
    <v-row class="text-center">
      <v-col cols="12">
        <v-card
          class="d-flex align-content-start flex-wrap"
          color="primary"
          flat
          tile
         
        >
          <v-card  class="pa-2 white--text" color="primary" outlined tile>Konaklama</v-card>
        </v-card>
      </v-col>
    </v-row>
    <v-row class="text-center">
      <v-col cols="12">
        <v-card
          class="d-flex align-content-start flex-wrap"
          color="grey lighten-2"
          flat
          tile
        >
          <v-card  class="pa-2" outlined tile>
           
            <span> Check-In </span><br>
            <span> 10:30 </span>
           
          </v-card>
          <v-card  class="pa-2" outlined tile>
           
            <span> Check-Out </span><br>
            <span> 14:30 </span>
            
          </v-card>
        </v-card>
      </v-col>
    </v-row>
    <v-row class="text-center">
      <v-col cols="12">
        <v-card
          class="d-flex align-content-start flex-wrap"
          color="primary"
          flat
          tile
         
        >
          <v-card  class="pa-2 white--text" color="primary" outlined tile>Tur Paketi</v-card>
        </v-card>
      </v-col>
    </v-row>
    <v-row class="text-center">
      <v-col cols="12">
        <v-card
          class="d-flex align-content-start flex-wrap"
          color="grey lighten-2"
          flat
          tile
        >
          <v-card  class="pa-2" outlined tile>
           
            <span> Yetişkin : </span><br>
            <span> Çocuk : </span><br>
            <span> Toplam : </span>
          </v-card>
          <v-card  class="pa-2" outlined tile>
           
            <span> 1 </span><br>
            <span> 0 </span><br>
            <span> 1 </span>
          </v-card>
          <v-card  class="pa-2" outlined tile>
            
            <span> 250 EUR </span><br>
            <span> 0 </span><br>
            <span class="text-h4"> 250 EUR </span><br>
          </v-card>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</v-flex>
        </v-layout>
    </v-card>
</div>
</template>
<script>
  export default {
    data () {
      return {
        e1: 0
 
      }
    }
  }
</script>